import { PLACE_TYPE_META, type PlaceType } from "./api";

const TYPE_ORDER = Object.keys(PLACE_TYPE_META) as PlaceType[];

/** Sorts place types by relevance order for explorers. */
export function sortPlaceTypes(types: PlaceType[]): PlaceType[] {
  return [...types].sort((a, b) => TYPE_ORDER.indexOf(a) - TYPE_ORDER.indexOf(b));
}
